import { Component, OnInit ,Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import {FileUploadService} from './../../../Services/file-upload.service';
import { DataApiService } from 'src/app/Services/data-api.service';
import { AlertRefreshComponent } from '../alert-refresh/alert-refresh.component';

export interface DialogData {
  datos: any;  
}


@Component({
  selector: 'app-modificar-usuario-motorizado',
  templateUrl: './modificar-usuario-motorizado.component.html',
  styleUrls: ['./modificar-usuario-motorizado.component.scss']
})
export class ModificarUsuarioMotorizadoComponent implements OnInit {

  public form = {
    id: this.data.datos.id,
    name: this.data.datos.name,
    surname:this.data.datos.surname,
    codigo_motorizado: this.data.datos.datos_motorizado.split("||")[0],
    placa_moto:this.data.datos.datos_motorizado.split("||")[1],
    telefono: this.data.datos.telefono1,
    usuario: this.data.datos.email,
    password: null,
    password_confirmation: null,
    file_name:null,
    base64textString:null,
    type:"user"
  }

  constructor(
    private dialog: MatDialog,
    private dataApi :DataApiService,
    private fileUploadService: FileUploadService,
    public dialogRef: MatDialogRef<ModificarUsuarioMotorizadoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData 
  ) { }

  filePreview(input){
    if(input.files && input.files[0]){
      const reader = new FileReader();
      reader.onload = (event)=>{
        document.getElementById("filePreview").innerHTML = `<img src="${event.target["result"]}" style="width:150px"/>`;
      }
      reader.readAsDataURL(input.files[0]);
    }
  }
  seleccionarArchivo(event){
    const files = event.target.files;
    const file = files[0]; 
    this.form.file_name = "user-"+event.target.files[0].name ;
    if(files && file){
      var reader = new FileReader();
      reader.onload= this._handleReaderLoadad.bind(this);      
      
      reader.readAsBinaryString(file)
    }
  }

  _handleReaderLoadad(readerEvent){
    const binaryString = readerEvent.target.result;   
    
    this.form.base64textString = btoa(binaryString)
  }

  modificarUsuarioMotorizado(){
    if(this.form.file_name!=null && this.form.base64textString !=null){     
      this.fileUploadService.uploadFile(this.form).subscribe();
    }
    this.dataApi.editarUsuarioMotorizado(this.form).subscribe(
      data  => this.handleResponse(data),
      error => console.log(error)
    ) 
  }
  handleResponse(data){
    console.log(data)
    this.dialog.closeAll(); 
    this.dialog.open(AlertRefreshComponent,{
      width:"200px",   
      data:{mensaje:"El usuario Motorizado ha sido modificado con éxito"},
      disableClose: false,
      autoFocus:true
    });     
  }
  ngOnInit() {
    console.log(this.data.datos);
    document.getElementById("filePreview").innerHTML="<img style='width:150px' src='assets/uploads/users/" + this.data.datos.foto + "'>";
    const file = document.getElementById("file");
    file.addEventListener("change",()=>{
    this.filePreview(file);
    })
  }

}
